import api from "./instance";
import { pickData } from "./util";

/**
 * Types
 */

export type Settings = {
  referenceLanguage: string;
};

/**
 * Endpoints
 */

export const getSettings = () => api.get<Settings>("/settings").then(pickData);
